import Link from 'next/link'; 
import {downloadLink } from '@/lib/utils.js'
import parse from 'html-react-parser'; 
import CartButton from '@/components/cart_button'

export default function CustomizableProductButtonArea({primarySpecSheet, cartActive, itemInCart, cart, product }) {

  const _cartButton = (_classes) => { 
   return(  <CartButton 
    cartActive={cartActive}
    itemInCart={itemInCart}
    cart={cart}
    product={product}
    _classes={_classes}
     />
  )
  }

    const defaultHTML = ( ) => {
      return ( 
        <>
          {primarySpecSheet && (
            <Link href={downloadLink(primarySpecSheet)}>
              <a
                className="lexcms-large-button lexcms-spec-sheet-button"
                target="_blank"
              >
                Specification Sheet
              </a>
            </Link>
          )}
          {_cartButton()} 
        </ >
      )

    }

  const renderAtKey = (product, key) => {
    let html = "" 
    product.product_page_customizations[key]?.forEach((d, i) =>  {
      html +=  d;
    })
    return html;
  }

  const positionHTML = (position) =>  {
    if (product.product_page_customizations &&  product.product_page_customizations[`button_area_${position}`]) {
      let html =  renderAtKey(product, `button_area_${position}`)
      return (
        parse(html, {replace(domNode) { 
          if (domNode.name === 'template' &&  domNode?.attribs?.id === 'lexcms-custom-cart-button' ){
            return  _cartButton(domNode.attribs.class)
          }
        }}
        ) 
      )
    }
  }


  return (
    <>
      {positionHTML('beforebegin')}
      <div className='lexcms-product-page-btns'>
        {positionHTML('afterbegin')}
        {!positionHTML('replace')  &&
            defaultHTML()
        }
        {positionHTML('replace')}
        {positionHTML('beforeend')}
      </div>
      {positionHTML('afterend')}
    </>
  )
}

